import { render, staticRenderFns } from "./FieldEmails.vue?vue&type=template&id=827a1cd4"
import script from "./FieldEmails.vue?vue&type=script&lang=js"
export * from "./FieldEmails.vue?vue&type=script&lang=js"
import style0 from "./FieldEmails.vue?vue&type=style&index=0&id=827a1cd4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QField from 'quasar/src/components/field/QField.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QChip,QTooltip,QField,QCheckbox});
